<div class="switch-container" (click)="OnClick()">
    <div class="switch-bar {{SwitchBarClass}}"></div>
    <div class="switch-thumb-container">
        <div class="switch-thumb {{SwitchButtonClass}}"></div>
    </div>    
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/switch/switch.html